import { render, staticRenderFns } from "./EditHarvest.vue?vue&type=template&id=0bb6416d&scoped=true"
import script from "./EditHarvest.vue?vue&type=script&lang=ts"
export * from "./EditHarvest.vue?vue&type=script&lang=ts"
import style0 from "./EditHarvest.vue?vue&type=style&index=0&id=0bb6416d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb6416d",
  null
  
)

export default component.exports